/* eslint-disable max-len */
import { groupEditTheme } from 'components/GroupEdit/theme';
import { scrollbarTheme } from 'components/Scrollbar/theme';
import { allCommentsModalTheme } from 'modals/AllCommentsModal/theme';
import { auditLogsTheme } from 'routes/pages/AuthorizedStack/AuditLogs/theme';
import { dpWdStatsTheme } from 'routes/pages/AuthorizedStack/Clients/ClientsList/Client/View/Statistics/DPWDStats/theme';
import { dashboardFolderFormTheme } from 'routes/pages/AuthorizedStack/Dashboards/FolderDashboards/Dashboard/Form/theme';
import { dashboardGraphsTheme } from 'routes/pages/AuthorizedStack/Dashboards/FolderDashboards/Dashboard/View/DashboardGraphs/theme';
import { integrationBuilderOperationForm } from 'routes/pages/AuthorizedStack/IntegrationBuilder/Adapter/View/Operation/Form/components/AreaWithVars/theme';
import { headerTheme } from 'routes/pages/AuthorizedStack/Layout/Header/theme';
import { notificationCenterTheme } from 'routes/pages/AuthorizedStack/Layout/NotificationCenter/theme';
import { navigationBarTheme } from 'routes/pages/AuthorizedStack/Layout/Sidebar/theme';
import { motoFormTheme } from 'routes/pages/AuthorizedStack/ManualTransaction/theme';
import { copyMerchantModalTheme } from 'routes/pages/AuthorizedStack/Merchants/CopyMerchant/theme';
import { merchantFormTheme } from 'routes/pages/AuthorizedStack/Merchants/Merchant/Form/theme';
import { changeRuleGroupEditTheme } from 'routes/pages/AuthorizedStack/Merchants/Merchant/View/ChangePaymentMethod/GroupEdit/theme';
import { paymentLinkQrModalTheme } from 'routes/pages/AuthorizedStack/Merchants/Merchant/View/PaymentLinks/PaymentLinkModal/theme';
import { cashierSettingTheme } from 'routes/pages/AuthorizedStack/MerchantsSettings/CashierSettings/Form/theme';
import { paymentMethodFormTheme } from 'routes/pages/AuthorizedStack/MerchantsSettings/PaymentMethods/PaymentMethod/Form/theme';
import { stylizationTheme } from 'routes/pages/AuthorizedStack/MerchantsSettings/Stylization/theme';
import { notificationHistoryTheme } from 'routes/pages/AuthorizedStack/NotificationHistory/theme';
import { pspParameterFormTheme } from 'routes/pages/AuthorizedStack/PspManagement/Psp/View/Parameters/Form/Create/theme';
import { addTLGroupTerminalLinksTheme } from 'routes/pages/AuthorizedStack/PspManagement/TerminalLinksGroups/TerminalLinkGroup/AddTLForm/theme';
import { copyLimitsTheme } from 'routes/pages/AuthorizedStack/PspManagement/TerminalLinksLimits/CopyLimits/theme';
import { terminalParametersTheme } from 'routes/pages/AuthorizedStack/PspManagement/Terminals/Terminal/TerminalParameters/theme';
import { terminalLinkGroupEditTheme } from 'routes/pages/AuthorizedStack/PspManagement/TerminalsLinks/GroupEdit/theme';
import { terminalLinkHealthTheme } from 'routes/pages/AuthorizedStack/PspManagement/TerminalsLinks/TerminalLink/View/Health/theme';
import { resetParameterTheme } from 'routes/pages/AuthorizedStack/PspManagement/TerminalsLinks/TerminalLink/View/Parameters/ResetParameterModal/theme';
import { requiredParametersTheme } from 'routes/pages/AuthorizedStack/PspManagement/TerminalsLinks/TerminalLink/View/RequiredParamsForm/theme';
import { reconciliationTheme } from 'routes/pages/AuthorizedStack/Reconciliation/theme';
import { notificationTemplatesTheme } from 'routes/pages/AuthorizedStack/Settings/Notification/Templates/Template/Form/theme';
import { settingsTheme } from 'routes/pages/AuthorizedStack/Settings/PortalSettings/theme';
import { workbookTheme } from 'routes/pages/AuthorizedStack/Settlement/SettlementContracts/SettlementContract/View/Workbook/theme';
import { gistViewTheme, gridViewTheme } from 'routes/pages/AuthorizedStack/theme';
import { themeEditorTheme } from 'routes/pages/AuthorizedStack/ThemeEditor/Editor/theme';
import { countryGroupsTheme } from 'routes/pages/AuthorizedStack/TrafficManagement/CountryGroups/theme';
import { bulkCopyTheme } from 'routes/pages/AuthorizedStack/TrafficManagement/RoutingRuleset/BulkCopy/theme';
import { routingRulesetGroupEditTheme } from 'routes/pages/AuthorizedStack/TrafficManagement/RoutingRuleset/GroupEdit/theme';
import { rulesetFormThem } from 'routes/pages/AuthorizedStack/TrafficManagement/RoutingRuleset/Ruleset/Form/theme';
import { revertStepBarTheme } from 'routes/pages/AuthorizedStack/TrafficManagement/RoutingRuleset/useRevertRulesetsModal/StepBar/theme';
import { revertPreviewTheme } from 'routes/pages/AuthorizedStack/TrafficManagement/RoutingRuleset/useRevertRulesetsModal/steps/Preview/theme';
import { routingHistoryTheme } from 'routes/pages/AuthorizedStack/Transactions/Transaction/RoutingHistory/theme';
import { transactionTheme } from 'routes/pages/AuthorizedStack/Transactions/Transaction/theme';
import { rolesAndPermissionsTheme } from 'routes/pages/AuthorizedStack/UserManagement/RolesAndPermissions/theme';
import { userFormTheme } from 'routes/pages/AuthorizedStack/UserManagement/Users/User/Form/theme';
import { userScopeSectionTheme } from 'routes/pages/AuthorizedStack/UserManagement/Users/User/ScopeSection/theme';
import { userManualTheme } from 'routes/pages/AuthorizedStack/UserManual/theme';
import { manualSectionTheme } from 'routes/pages/AuthorizedStack/UserManual/ViewSection/theme';
import { authenticationTheme } from 'routes/pages/UnauthorizedStack/Authentication/theme';
import { COMPONENTS_DEFAULT_THEMES, COMPONENTS_NAMES } from 'theme/constants';

export const THEME = {
  components: COMPONENTS_DEFAULT_THEMES,
  main: {
    bg: 'palette.surface.1',
    font: 'Inter, Arial, sans-serif',
    scrollbar: scrollbarTheme,
  },

  authentication: authenticationTheme,

  header: headerTheme,
  navigationBar: navigationBarTheme,
  notificationCenter: notificationCenterTheme,
  notificationHistory: notificationHistoryTheme,

  gistView: gistViewTheme,
  gridView: gridViewTheme,
  groupEdit: groupEditTheme,

  transactions: {
    routingHistory: routingHistoryTheme,
    view: transactionTheme,
  },

  users: {
    form: userFormTheme,
    scopeSection: userScopeSectionTheme,
  },

  clients: {
    dpWdStats: dpWdStatsTheme,
    form: {
      confirmModal: { title: 'palette.primary.99' },
    },
  },

  terminalLinks: {
    copyLimits: copyLimitsTheme,
    groupEdit: terminalLinkGroupEditTheme,
    terminalLink: {
      health: terminalLinkHealthTheme,
      requiredParameters: requiredParametersTheme,
      resetParameter: resetParameterTheme,
    },
  },

  terminals: {
    terminalParameters: terminalParametersTheme,
  },

  pspParameterForm: pspParameterFormTheme,

  allCommentsModal: allCommentsModalTheme,

  countryGroups: {
    grid: countryGroupsTheme,
  },

  dashboard: {
    dashboardGraphs: dashboardGraphsTheme,
    folderForm: dashboardFolderFormTheme,
  },

  merchantSettings: {
    cashierSettings: {
      form: cashierSettingTheme,
    },
    paymentMethods: {
      form: paymentMethodFormTheme,
    },
  },

  routingRuleset: {
    bulkCopy: bulkCopyTheme,
    form: rulesetFormThem,
    groupEdit: routingRulesetGroupEditTheme,
    revert: {
      preview: revertPreviewTheme,
      stepBar: revertStepBarTheme,
    },
  },

  merchants: {
    changeRuleGroupEdit: changeRuleGroupEditTheme,
    copy: copyMerchantModalTheme,
    form: merchantFormTheme,
    qrModal: paymentLinkQrModalTheme,
  },

  terminalLinksGroup: {
    addTerminalLink: addTLGroupTerminalLinksTheme,
  },

  settlement: {
    workbook: workbookTheme,
  },

  integrationBuilder: {
    operationForm: integrationBuilderOperationForm,
  },

  reconciliation: reconciliationTheme,

  auditLogs: auditLogsTheme,
  manualSection: manualSectionTheme,
  motoForm: motoFormTheme,
  rolesAndPermissions: rolesAndPermissionsTheme,
  settings: settingsTheme,
  stylization: stylizationTheme,
  themeEditor: themeEditorTheme,
  userManual: userManualTheme,

  notificationTemplates: notificationTemplatesTheme,

  wrongPages: {
    accessForbidden: COMPONENTS_NAMES.WRONG_PAGE,
    maintenance: COMPONENTS_NAMES.WRONG_PAGE,
    notFound: COMPONENTS_NAMES.WRONG_PAGE,
    permissionDenied: COMPONENTS_NAMES.WRONG_PAGE,
    somethingWrong: COMPONENTS_NAMES.WRONG_PAGE,
  },
};
